import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";
import BesoinEditor from "../BesoinEditor";
import Input from "../../../Atoms/Input";
import styled from "styled-components";
import React from "react";
import { useState } from "react";
import { SDE2024MultiSelectOptionsA } from "../../../Utils/Listings"

function valuesToOptions(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value));
}

const PopA1 = (props) => {


    const defaultValues = props.defaultValues || {};

    const { i18n } = useTranslation('common');

    return (<>
        <h2 className="formtitle" >{i18n.language === 'fr' ? "Vos besoins" : "Your needs"}</h2><br/>
        <span>{i18n.language === 'fr' ? "Votre offre (typologie de mobiliers / objets / produits)" : "Your offer (typology of furniture / objects / products)"}</span>
        <Input type="text" style={{ width: "100%", zIndex: "0" }} name="offre" placeholder={i18n.language === "fr" ? "Votre offre" : "Your offer"} defaultValue={defaultValues?.offre} /><br/><br/>
        <span>{i18n.language === 'fr' ? "Vos savoir-faire, matériaux et techniques" : "Your know-how, materials and techniques"}</span>
        <Input type="text" style={{ width: "100%", zIndex: "0" }} name="savoir_faire" placeholder={i18n.language === "fr" ? "Vos savoir-faire" : "Your know-how"} defaultValue={defaultValues?.savoir_faire} /><br/><br/>
        <span>{i18n.language === 'fr' ? "La place du design dans votre entreprise" : "The place of design in your company"}*</span><br/><br/>
        <div className="decal">
            <label><input type="checkbox" name="interne" defaultChecked={defaultValues?.interne}/>{i18n.language === 'fr' ? "Vous avez des designers internes" : "You have internal designers"}</label>
            <label><input type="checkbox" name="etude" defaultChecked={defaultValues?.etude}/>{i18n.language === 'fr' ? "Vous avez un bureau d’étude intégré" : "You have an integrated design office"}</label>
            <label><input type="checkbox" name="collab" defaultChecked={defaultValues?.collab}/>{i18n.language === 'fr' ? "Vous collaborez de manière ponctuelle avec des designers externes" : "You collaborate occasionally with external designers"}</label>
            <label><input type="checkbox" name="da" defaultChecked={defaultValues?.da}/>{i18n.language === 'fr' ? "Vous avez un directeur artistique" : "You have an artistic director"}</label>
            <label><input type="checkbox" name="premiere" defaultChecked={defaultValues?.premiere}/>{i18n.language === 'fr' ? "Vous participez pour développer une première collaboration avec un designer externe" : "You are participating to develop a first collaboration with an external designer"}</label>
        </div>
        <br/><br/>
        <br />
        <h2 className="formtitle" >{i18n.language === 'fr' ? "Vos projets" : "Your projects"}</h2>
        <BesoinEditor projets={props.projets} setDeletedProjets={props.setDeletedProjets} setProjets={props.setProjets} />
    </>);
}

export default PopA1;